import clsx from 'clsx'
import { tv } from 'tailwind-variants'

export const FLEX_VARIANTS = tv({
  base: clsx('tw-flex'),
  variants: {
    direction: {
      column: clsx('tw-flex-col'),
      row: clsx('tw-flex-row'),
    },
    gap: {
      1: 'tw-gap-1',
      2: 'tw-gap-2',
      3: 'tw-gap-3',
      4: 'tw-gap-4',
      5: 'tw-gap-5',
      6: 'tw-gap-6',
      7: 'tw-gap-7',
      8: 'tw-gap-8',
    },
    justify: {
      center: clsx('tw-justify-center'),
      between: clsx('tw-justify-between'),
      end: clsx('tw-justify-end'),
    },
    align: {
      center: clsx('tw-items-center'),
      baseline: clsx('tw-items-baseline'),
      start: clsx('tw-items-start'),
      end: clsx('tw-items-end'),
    },
    center: {
      true: clsx('tw-items-center tw-justify-center'),
    },
    wrap: {
      true: clsx('tw-flex-wrap'),
      false: clsx('tw-flex-nowrap'),
    },
  },
})
